module.exports = {"title":"Campaign Not Found","description":"The requested campaign was not found in our system. You may have entered a wrong URL."}